/**
 * 認証関連のイベントリスナー
 * 認証システムのイベント処理を管理
 */

import { AUTH_EVENTS } from "@/lib/events/constants";
import { addEventListener } from "@/lib/events/helpers";

/**
 * 認証関連のイベントリスナーを初期化
 */
export const initializeAuthEventListeners = () => {
  // Auth関連イベントリスナー
  const handleAuthLogout = () => {
    // 動的インポートでauth関連の処理を取得
    import("@/lib/auth").then(({ useAuthStore }) => {
      const authStore = useAuthStore.getState();
      authStore.logout();
    });
  };

  const handleAuthUnauthorized = () => {
    // 401エラー時の処理
    import("@/lib/auth").then(({ useAuthStore }) => {
      const authStore = useAuthStore.getState();
      authStore.logout();
    });
  };

  const handleAuthRefreshSession = () => {
    // セッションリフレッシュ処理
    import("@/lib/auth").then(({ useAuthStore }) => {
      const authStore = useAuthStore.getState();
      authStore.refreshUserSession();
    });
  };

  // イベントリスナーを登録
  addEventListener(AUTH_EVENTS.LOGOUT, handleAuthLogout);
  addEventListener(AUTH_EVENTS.UNAUTHORIZED, handleAuthUnauthorized);
  addEventListener(AUTH_EVENTS.REFRESH_SESSION, handleAuthRefreshSession);
};
